import request from '@/utils/request'
const apiPath = '/cust/customerOrder'
import { downloadBlob } from '@/utils/download'
const customerOrderApi = {
  /**
   * 新增【客户订单】
   */
  create(data) {
    return request.post(apiPath + '/tee/saveBatch', data)
  },
  /**
   * 修改【客户订单】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【客户订单】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  fetchForList(query) {
    return request.get(apiPath + '/tee', { params: query })
  },
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【客户订单】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【客户订单】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  }
}
export default customerOrderApi
